"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSourceCandidatesResponseDto = exports.VenueSourceCandidateDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class VenueSourceCandidateDto {}
exports.VenueSourceCandidateDto = VenueSourceCandidateDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Stable UI/provider key, e.g. overture:<gers-id> or osm:node/123'
}), __metadata("design:type", String)], VenueSourceCandidateDto.prototype, "providerKey", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Overture GERS id when from Overture (no prefix)'
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "overtureId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'OSM element id when from OSM, e.g. node/123'
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "osmId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSourceCandidateDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], VenueSourceCandidateDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSourceCandidateDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String]
}), __metadata("design:type", Array)], VenueSourceCandidateDto.prototype, "dataSources", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'True when a venue with the same overtureId or osmId already exists.'
}), __metadata("design:type", Boolean)], VenueSourceCandidateDto.prototype, "alreadyExists", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'publicId of the existing Ivy venue when alreadyExists is true.'
}), __metadata("design:type", Object)], VenueSourceCandidateDto.prototype, "existingPublicId", void 0);
class VenueSourceCandidatesResponseDto {}
exports.VenueSourceCandidatesResponseDto = VenueSourceCandidatesResponseDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: [VenueSourceCandidateDto]
}), __metadata("design:type", Array)], VenueSourceCandidatesResponseDto.prototype, "candidates", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  description: 'Non-fatal source errors (e.g. Overpass timeout).'
}), __metadata("design:type", Array)], VenueSourceCandidatesResponseDto.prototype, "errors", void 0);
//# sourceMappingURL=VenueSourceCandidate.dto.js.map